// Filter that fakes the over-smooth, glossy "typical AI" look on the same still.
export const AI_FILTER = "blur(0.6px) saturate(1.5) contrast(0.85)";

// Points the director's scan checks. x / y are % positions on the scene.
export const scanPins = [
  { id: "colour", x: 33, y: 17, side: "right", pass: "BRAND COLOUR ✓", fail: "OFF-BRAND COLOUR ✕" },
  { id: "eyes", x: 47, y: 27, side: "left", pass: "EYE LIGHT ✓", fail: "DEAD EYES ✕" },
  { id: "skin", x: 57, y: 38, side: "right", pass: "SKIN TEXTURE ✓", fail: "PLASTIC SKIN ✕" },
  { id: "rain", x: 67, y: 60, side: "right", pass: "RAIN PHYSICS ✓", fail: "FLOATY PHYSICS ✕" },
  { id: "hands", x: 40, y: 86, side: "right", pass: "HAND ANATOMY ✓", fail: "MELTING HANDS ✕" },
] as const;

// Cropped close-ups of each tell, taken from the AI side of the scene.
export const defeatedTells = [
  { word: "Plastic skin", x: 56, y: 32, zoom: 420 },
  { word: "Melting hands", x: 38, y: 92, zoom: 380 },
  { word: "Dead eyes", x: 50, y: 25, zoom: 560 },
  { word: "Floaty physics", x: 50, y: 52, zoom: 420 },
  { word: "Generic faces", x: 52, y: 26, zoom: 300 },
  { word: "Off-brand colour", x: 33, y: 18, zoom: 360 },
];
